export const pageSizes = [10, 25, 50]
